import { useSyncExternalStore } from "react";

import type { Theme } from "@fanos/omnium-bridge";

import { getTheme, subscribeTheme } from "@/lib/theme";

/** Light or dark for framed apps, kept up to date. */
export function useTheme(): Theme {
  return useSyncExternalStore(subscribeTheme, getTheme, () => "light");
}
